import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import get from 'lodash/get';
import { prop } from 'styled-tools';
import { Formik } from 'formik';
import { createChineseClothingCompetitionUser, getJoinedSchools } from '../../../api/competition';
import { withAuth } from '../../../context/auth';
import { withLoading } from '../../../context/loading';
import { createBrand, createCompetitionClothingTemplate, createFile, createGallery, createGalleryAllowedQRCode, createQRCode, createUUID, importNewUser, importQrCodeId, importQrCodeImage } from '../../../api/gallery';
import createQRCodeImages from '../../../utils/QrCodeImages';
import { dresses } from '../../../constants/dresses';
import { graduationGowns } from '../../../constants/graduation_gowns';
import Bluebird from 'bluebird';

const Container = styled(Flex)`
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  width: 100%;
  height: 100%;
  padding: 10px;
`;

const DIGITAL_56_COMPETITION_ID = '38401590-9506-4a0b-8870-5e2d48383cb6';
const DIGITAL_56 = 'Digital 56';
const CHINESE_DRESS_56 = 'Chinese Dress 56';
const GRADUATION_GOWN = 'Graduation Gown';

const DIGITAL_56_FOLDER_NAME = 'digital_56';
const CHINESE_DRESS_56_FOLDER_NAME = 'chinese_dress_56';
const GRADUATION_GOWN_FOLDER_NAME = 'graduation_gown';

const calwalkIds = {
  [DIGITAL_56]: 'fddb2201-731c-42b4-a886-067b231801cd',
  [CHINESE_DRESS_56]: '6e0d25f2-1d22-432a-83e1-749f3fab0f52',
  [GRADUATION_GOWN]: 'a7a7e936-07c1-4a46-9926-6a52837cf083',
}

const designSets = [
  {
    name: DIGITAL_56,
    competitionId: DIGITAL_56_COMPETITION_ID,
  },
  {
    name: CHINESE_DRESS_56,
    competitionId: null,
  },
  {
    name: GRADUATION_GOWN,
    competitionId: null,
  },
];

class CreateGalleryPage extends React.Component {

  state = {
    galleryId: '',
    uuids: [],
    folder: '',
    createdPdfList: [],
  }

  componentDidMount() {
    const params = {
      $select: 'school',
      $distinct: true,
    }
    const { auth, setAuth } = this.props;
    return getJoinedSchools(params, auth, setAuth).then(obj => {
      if (obj.status === 200 && !obj.error) {
        this.setState({ joinedSchools: obj.data.length });
      }
    })
  }

  handleCreateUser = (values) => {
    const { auth, setAuth } = this.props;
    const body = {
      username: values.email,
      email: values.email,
      group: values.group,
      area: values.area,
      school: values.school,
    }
    return createChineseClothingCompetitionUser(body, auth, setAuth)
      .then(() => {
        alert('成功登記');
        // window.location.reload();
      })
      .catch(err => {
        const errorResponse = get(err, 'response');
        const errorMessage = get(errorResponse, ['data', 'error'], '');
        if (errorMessage) {
          alert(errorMessage);
        }
      })
  }

  handleCreateQRCode = (values, qrCodeId, index) => {
    const { auth, setAuth } = this.props
    const is56ChineseDresses = [DIGITAL_56, CHINESE_DRESS_56].includes(values.design_set);
    let clothings, folderName;
    switch (values.design_set) {
      case DIGITAL_56:
        clothings = dresses;
        folderName = DIGITAL_56_FOLDER_NAME;
        break;
      case CHINESE_DRESS_56:
        clothings = dresses;
        folderName = CHINESE_DRESS_56_FOLDER_NAME;
        break;
      case GRADUATION_GOWN:
        clothings = graduationGowns;
        folderName = GRADUATION_GOWN_FOLDER_NAME;
        break;
      default:
        clothings = null;
    }
    if (qrCodeId) {
      const qrCodePostBody = {
        qr_code: qrCodeId,
        sequence: index + 1,
        clothing_preset: clothings[index].id,
        url: is56ChineseDresses ? dresses[index].link : values.url,
        limited: values.limited,
        initial_upload_limit: values.initial_upload_limit,
        claimed: false,
        marker_type: 0,
        catwalk_is_ar_mode: false,
        catwalk_tap_button_to_start: false,
        access_role: 0,
        catwalk: values.catwalk_id ? values.catwalk_id : calwalkIds[values.design_set],
      }
      return createQRCode(qrCodePostBody, auth, setAuth).then(obj => {
        if (obj && obj.status === 201) {
          const galleryAllowedQRCodePostBody = {
            qr_code: qrCodeId,
            gallery: values.gallery_id
          }
          return createGalleryAllowedQRCode(galleryAllowedQRCodePostBody, auth, setAuth).then(obj2 => {
            if (obj2 && obj2.status === 201) {
              const filePostBody = {
                file_id: qrCodeId,
                url: `https://arfashiondesigner.joyaethercloud.com/ar_fashion_designer/contents/${folderName}/${index+1}_${qrCodeId}.pdf`
              }
              return createFile(filePostBody, auth, setAuth).then(obj3 => {
                if (obj3 && obj.status === 201 && values.is_competition) {
                  const fileId = obj3.data.file_id;
                  const competitionClothingTemplatePostBody = {
                    clothing_preset: clothings[index].id,
                    competition: designSets.find(designSet => designSet.name === values.design_set).competitionId,
                    file: fileId,
                    group: values.group ? values.group : null,
                  }
                  return createCompetitionClothingTemplate(competitionClothingTemplatePostBody, auth, setAuth);
                } else {
                  return obj3;
                }
              })
            }
          })
        }
      });
    }
  }

  handleCreateUUID = (values) => {
    if (values.uuid_count) {
      let uuidCount = values.uuid_count;
      if ([CHINESE_DRESS_56, DIGITAL_56].includes(values.design_set)) {
        uuidCount = uuidCount * 56;
      } else if (values.design_set === GRADUATION_GOWN) {
        uuidCount = uuidCount * 4;
      } 
      return createUUID(uuidCount).then(obj => {
        if (obj && obj.status === 200) {
          const uuids = obj.data.split('\r\n')
          let uuidsTSV = '';
          const inputText = document.getElementById('input_text');
          inputText.innerHTML = obj.data;

          return Bluebird.map(uuids, (uuid, index) => {
            uuidsTSV += `${index + 1}\t${uuid}\n`;
            if ([CHINESE_DRESS_56, DIGITAL_56].includes(values.design_set) && index > 55) {
              index %= 56
            } else if (values.design_set === GRADUATION_GOWN && index > 4) {
              index %= 4
            }
            return this.handleCreateQRCode(values, uuid, index);
          }, {
              concurrency: 4
          }).then(promises => {
              this.setState({ uuids: uuids });
            
              const element = document.createElement('a');
              element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(uuidsTSV));
              element.setAttribute('download', 'uuids.txt');
              
              element.style.display = 'none';
              document.body.appendChild(element);
              
              element.click();
              
              document.body.removeChild(element);

              if (promises.every(promise => promise && promise.status === 201)) {
                alert('QR Codes created successfully');
              } else {
                alert('Error occured while creating QR Codes');
              }
          }).catch(console.error);
        }
      })
    }
  }

  handleCreateGallery = (galleryName) => {
    const { auth, setAuth } = this.props;
    const brandPostBody = { name: galleryName };
    return createBrand(brandPostBody, auth, setAuth).then(obj => {
      if (obj && obj.status === 201) {
        const brandId = obj.data.brand_id;
        const galleryPostBody = {
          brand: brandId,
          name: galleryName,
          // to be modified
          clothing_design_set_count: 0,
          like_count: 0,
          public: true,
          mix_and_match_allowed: true,
          replace_old_design_on_upload: true,
          qr_code_restricted: true,
          only_one_design_visible_per_user: false,
          email_required: false,
          write_only: true,
          cover_image: '5e6189c9-d5a1-4093-83db-594201124260',
          file: 'f9147e9f-9b64-4fee-a0f7-d8d4fee143aa',
          android_file: '3c374462-b5a9-44de-ba3e-5e3ede293dc9',
          json_attributes: '{"display_settings":{"positions":[{"local_position":{"x":4,"y":-0.25,"z":-1.7},"local_euler_angles":{"x":0,"y":-90,"z":0}},{"local_position":{"x":4,"y":-0.25,"z":-3.7},"local_euler_angles":{"x":0,"y":-90,"z":0}},{"local_position":{"x":3,"y":-0.25,"z":-4.784848},"local_euler_angles":{"x":0,"y":-8.936,"z":0}},{"local_position":{"x":1,"y":-0.25,"z":-4.887469},"local_euler_angles":{"x":0,"y":-2.877,"z":0}},{"local_position":{"x":-1,"y":-0.25,"z":-4.887469},"local_euler_angles":{"x":0,"y":2.877,"z":0}},{"local_position":{"x":-3,"y":-0.25,"z":-4.784848},"local_euler_angles":{"x":0,"y":8.936,"z":0}},{"local_position":{"x":-4,"y":-0.25,"z":-3.7},"local_euler_angles":{"x":0,"y":90,"z":0}},{"local_position":{"x":-4,"y":-0.25,"z":-1.7},"local_euler_angles":{"x":0,"y":90,"z":0}}],"trigger_collider":[{"type":"box","center":{"x":0,"y":1.25,"z":0.625},"size":{"x":0.5,"y":3,"z":1.5}},{"type":"capsule","center":{"x":0,"y":1.25,"z":0},"radius":0.75,"height":2.5,"direction":"y"}]},"camera_settings":{"character_controller":{"center":{"x":0,"y":-0.5575,"z":0},"radius":0.4,"height":1.915},"positions":{"awake":{"local_position":{"x":0.05,"y":1.5,"z":-0.02},"local_euler_angles":{"x":8.5,"y":-180,"z":0}},"initial":{"local_position":{"x":0.05,"y":1.5,"z":-0.02},"local_euler_angles":{"x":8.5,"y":-180,"z":0}}}}}',
          url: 'https://www.ar.toys/term-of-use/',
        }
        createGallery(galleryPostBody, auth, setAuth).then(res => {
          if (res && res.status === 201) {
            this.setState({galleryId: res.data.gallery_id})
            alert("Gallery created");
          }
        });
      }
    })
  }

  handleUploadQrCodeImage = (event) => {
    const { auth, setAuth } = this.props;
    const { folder } = this.state;
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    return importQrCodeImage(formData, auth, setAuth).then(obj => {
      if (obj && obj.status === 200) {
        const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
        const sortedList = obj.data.file_names.sort(collator.compare);
        this.setState({ createdPdfList: sortedList });
      }
    });
  }

  handleImportNewUser = (event) => {
    const { auth, setAuth } = this.props;
    const { folder } = this.state;
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    return importNewUser(formData, auth, setAuth).then(obj => {
      if (obj && obj.data.result === 'success') {
        alert("File uploaded");
      } else {
        alert("File uploaded with errors");
      }
    });
  }

  handleUploadQrCodeId = (event) => {
    const { auth, setAuth } = this.props;
    const file = event.target.files[0];

    const formData = new FormData();
    formData.append('file', file);
    return importQrCodeId(formData, auth, setAuth).then(obj => {
      if (obj && obj.status === 200) {
        alert("Upload Succesfully")
      } else {
        alert("Upload Failed")
      }
    });
  }

  handleChangeDesignSet = (event, setFieldValue) => {
    const designSet = event.target.value;
    setFieldValue('design_set', designSet);
    switch (designSet) {
      case DIGITAL_56:
        this.setState({ folder: DIGITAL_56_FOLDER_NAME });
        break;
      case CHINESE_DRESS_56:
        this.setState({ folder: CHINESE_DRESS_56_FOLDER_NAME });
        break;
      case GRADUATION_GOWN:
        this.setState({ folder: GRADUATION_GOWN_FOLDER_NAME });
        break;
      default:
        break;
    }
  }

  render() {
    const initialValues = {
      is_competition: false,
      group: '',
      design_set: '',
      uuid_count: null,
      gallery_name: '',
      limited: false,
      initial_upload_limit: 3,
      clothing_preset_id: null,
      gallery_id: null,
      catwalk_id: null,
      competition_id: null,
      url: null
    }
    const { galleryId, createdPdfList } = this.state;

    return (
      <Container>

        <Formik
          initialValues={{...initialValues}}
        >
          {({ values, handleChange, handleBlur, setFieldValue, ...props }) => (
            <form>
              <Flex mt="1rem" flexDirection="column">
                <Flex flexDirection="row">
                  <Flex mr="1rem">
                    Gallery Name
                  </Flex>
                  <input
                    type="text"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.gallery_name}
                    name="gallery_name"
                    />
                  <button type="button" onClick={()=> this.handleCreateGallery(values.gallery_name)}>Create Gallery</button>
                </Flex>
                <Flex>
                  Gallery ID: {galleryId}
                </Flex>
              </Flex>

              <Flex flexDirection="column" mt="2rem">
                <Flex>
                  <Flex mr="1rem">
                    Is Competition
                  </Flex>
                  <input
                    type="checkbox"
                    style={{ width: 100 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.is_competition}
                    checked={values.is_competition}
                    name="is_competition"
                  />
                </Flex>
                {values.is_competition && <Flex>
                  <Flex mr="1rem">
                    Group
                  </Flex>
                  <input
                    type="text"
                    style={{ width: 100 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.group}
                    name="group"
                  />
                </Flex>}
                <Flex>
                  <Flex mr="1rem">
                    Design Set
                  </Flex>
                  <select
                    name="design_set"
                    style={{ width: 200 }}
                    onChange={(e)=>this.handleChangeDesignSet(e, setFieldValue)}
                    onBlur={handleBlur}
                    value={values.design_set}
                  >
                    <option value={null}>---</option>
                    {designSets.map(designSet => {
                      if (values.is_competition) {
                        return designSet.competitionId && <option value={designSet.name}>{designSet.name}</option>
                      } else {
                        return !designSet.competitionId && <option value={designSet.name}>{designSet.name}</option>
                      }
                    })}
                  </select>
                </Flex>
                <Flex>
                  <Flex mr="1rem">
                    QR Code count
                  </Flex>
                  <input
                    type="number"
                    style={{ width: 100 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.uuid_count}
                    name="uuid_count"
                  />
                </Flex>
                <Flex>
                  <Flex mr="1rem">
                    Is Limited
                  </Flex>
                  <input
                    type="checkbox"
                    style={{ width: 100 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.limited}
                    checked={values.limited}
                    name="limited"
                  />
                </Flex>
                <Flex>
                  <Flex mr="1rem">
                    Upload Limit
                  </Flex>
                  <input
                    type="num"
                    style={{ width: 100 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.initial_upload_limit}
                    name="initial_upload_limit"
                  />
                </Flex>
                {/* {!values.competition_id && <Flex>
                  <Flex mr="1rem">
                    Clothing Preset ID
                  </Flex>
                  <input
                    type="text"
                    style={{ width: 200 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.clothing_preset_id}
                    name="clothing_preset_id"
                  />
                </Flex>} */}
                <Flex>
                  <Flex mr="1rem">
                    Catwalk ID
                  </Flex>
                  <input
                    type="text"
                    style={{ width: 200 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.catwalk_id}
                    name="catwalk_id"
                  />
                </Flex>
                <Flex>
                  <Flex mr="1rem">
                    Gallery ID
                  </Flex>
                  <input
                    type="text"
                    style={{ width: 200 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.gallery_id}
                    name="gallery_id"
                  />
                </Flex>
                {values.competition_id !== DIGITAL_56_COMPETITION_ID && <Flex>
                  <Flex mr="1rem">
                    URL
                  </Flex>
                  <input
                    type="text"
                    style={{ width: 200 }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.url}
                    name="url"
                  />
                </Flex>}
                <button type="button" onClick={()=>this.handleCreateUUID(values)}>Create UUID</button>
              </Flex>
              </form>
            )}
        </Formik>
        
        <Flex mt="2rem">
          <form id="generate_qr_code_form">
            <fieldset id="form_fieldset">
              <label htmlFor="qrcode_textarea">Multiple QR code separated by new line:</label>
              <br />
              <textarea id="input_text" name="input_text" rows="10" cols="40"></textarea>
              <br />
              <button type="submit" onClick={createQRCodeImages}>Generate QR images</button>
            </fieldset>
          </form>
          <div id="error_message_area"></div>
          <hr/>
          <div id="output_area"></div>
        </Flex>

        <Flex mt="2rem">
          <label htmlFor="qr_code_id">Select QR Code ID File</label>
          <input onChange={this.handleUploadQrCodeId} type="file" id="qr_code_id" />
        </Flex>

        <Flex mt="2rem">
          <label htmlFor="qr_code_image">Select QR Code Image Folder</label>
          <input onChange={this.handleUploadQrCodeImage} type="file" id="qr_code_image" />
        </Flex>
        
        <Flex mt="2rem">
          <label htmlFor="import_new_user">Import New User</label>
          <input onChange={this.handleImportNewUser} type="file" id="import_new_user" />
        </Flex>

        <Flex mt="2rem" flexDirection="column">
          Created PDF(s):
          {createdPdfList.map((pdf, index) => <Flex key={index}>{`https://arfashiondesigner.joyaethercloud.com/ar_fashion_designer/contents${pdf}`}</Flex>)}
        </Flex>
      </Container>
    );
  }
}

CreateGalleryPage.propTypes = {
  auth: PropTypes.object,
  setAuth: PropTypes.func,
};

CreateGalleryPage.defaultProps = {
  auth: null,
  setAuth: () => {},
};

export default withAuth(withLoading(CreateGalleryPage));
